import type { SvgProps } from "replo-utils/react/components";

import * as React from "react";

import { Svg } from "replo-utils/react/components";

const Image = (props: SvgProps) => (
  <Svg width={22} height={22} viewBox="0 0 22 22" fill="none" {...props}>
    <g filter="url(#filter0_iin_1097_19240)">
      <path
        d="M17.6667 3H7C6.64638 3 6.30724 3.14048 6.05719 3.39052C5.80714 3.64057 5.66667 3.97971 5.66667 4.33333V5.66667H4.33333C3.97971 5.66667 3.64057 5.80714 3.39052 6.05719C3.14048 6.30724 3 6.64638 3 7V17.6667C3 18.0203 3.14048 18.3594 3.39052 18.6095C3.64057 18.8595 3.97971 19 4.33333 19H15C15.3536 19 15.6928 18.8595 15.9428 18.6095C16.1929 18.3594 16.3333 18.0203 16.3333 17.6667V16.3333H17.6667C18.0203 16.3333 18.3594 16.1929 18.6095 15.9428C18.8595 15.6928 19 15.3536 19 15V4.33333C19 3.97971 18.8595 3.64057 18.6095 3.39052C18.3594 3.14048 18.0203 3 17.6667 3ZM7 4.33333H17.6667V10.115L16.275 8.72333C16.025 8.47347 15.686 8.33312 15.3325 8.33312C14.979 8.33312 14.64 8.47347 14.39 8.72333L8.11417 15H7V4.33333ZM15 17.6667H4.33333V7H5.66667V15C5.66667 15.3536 5.80714 15.6928 6.05719 15.9428C6.30724 16.1929 6.64638 16.3333 7 16.3333H15V17.6667ZM9 7.66667C9 7.40296 9.0782 7.14517 9.22471 6.92591C9.37122 6.70664 9.57945 6.53574 9.82309 6.43483C10.0667 6.33391 10.3348 6.30751 10.5935 6.35895C10.8521 6.4104 11.0897 6.53739 11.2761 6.72386C11.4626 6.91033 11.5896 7.1479 11.641 7.40655C11.6925 7.66519 11.6661 7.93328 11.5652 8.17691C11.4643 8.42055 11.2934 8.62878 11.0741 8.77529C10.8548 8.9218 10.597 9 10.3333 9C9.97971 9 9.64057 8.85952 9.39052 8.60948C9.14048 8.35943 9 8.02029 9 7.66667Z"
        fill="url(#paint0_linear_1097_19240)"
      />
    </g>
    <defs>
      <filter
        id="filter0_iin_1097_19240"
        x="-0.895304"
        y="-0.417681"
        width="23.5522"
        height="22.9375"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-1.2288" dy="0.853333" />
        <feGaussianBlur stdDeviation="2.048" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.152941 0 0 0 0 0.290196 0 0 0 0 0.886275 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1097_19240"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="0.989867" dy="-0.750933" />
        <feGaussianBlur stdDeviation="2.11968" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 0.701961 0 0 0 0 0.764706 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_1097_19240"
          result="effect2_innerShadow_1097_19240"
        />
        <feTurbulence
          type="fractalNoise"
          baseFrequency="58.59375 58.59375"
          stitchTiles="stitch"
          numOctaves="3"
          result="noise"
          seed="2877"
        />
        <feColorMatrix in="noise" type="luminanceToAlpha" result="alphaNoise" />
        <feComponentTransfer in="alphaNoise" result="coloredNoise1">
          <feFuncA
            type="discrete"
            tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0"
          />
        </feComponentTransfer>
        <feComposite
          operator="in"
          in2="effect2_innerShadow_1097_19240"
          in="coloredNoise1"
          result="noise1Clipped"
        />
        <feFlood floodColor="rgba(239, 25, 110, 0.5)" result="color1Flood" />
        <feComposite
          operator="in"
          in2="noise1Clipped"
          in="color1Flood"
          result="color1"
        />
        <feMerge result="effect3_noise_1097_19240">
          <feMergeNode in="effect2_innerShadow_1097_19240" />
          <feMergeNode in="color1" />
        </feMerge>
      </filter>
      <linearGradient
        id="paint0_linear_1097_19240"
        x1="20.728"
        y1="1.528"
        x2="12.8296"
        y2="25.257"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EF196E" />
        <stop offset="1" stopColor="#274AE2" />
      </linearGradient>
    </defs>
  </Svg>
);

export default Image;
